import "./ROESetupStyle.css";

import { AuthService, ClientService } from "../../services";
import {
  BackdropCircularProgress,
  DeleteConfirmationDialog,
  EnhancedButtonPrimeReact,
  EnhancedButtonPrimeReactSeverity,
  EnhancedCheckboxRHF,
  EnhancedDropDownRHF,
  EnhancedDropDownRHFWithLabel,
  EnhancedRadioGroupRHF,
  EnhancedRadioGroupRHFWithLabel,
  EnhancedSnackbar,
  EnhancedTextAreaFieldRHF,
  IEnhancedDropDownItem,
  IResponse,
  IServerError,
  ITest,
  LabelPosition,
  RHookFormDatePicker,
  RHookFormMaskedTextField,
  RHookFormMaskedTextFieldWithLabel,
  RHookFormNumberField,
  RHookFormNumberFieldWithLabel,
  RHookFormTextField,
  SingleColumnLayout,
  StandardPanel,
  TopRowTwoColumnLayout,
  TwoColumnLayout,
} from "@websential/cosmic-v20";
import {
  Block17BSetupFieldsPanel,
  Block17COtherMoniesFieldsTable,
  CompleteAccordingToChartSetupFieldsPanel,
} from "./Panels";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
  INITIAL_SNACKBAR_DATA,
  T4_SETUP_SCREEN_SLUG,
} from "../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import { formatDate, formatDateToShow, getPayFrequencyLabelByGivingCode, scrollPanelFieldsToTop, sortDDLByLabel, useNavigateToLogout } from "../../common/Common";
import {
  setSelectedActivityLogActions,
  setSelectedStickyNavBar,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Block17BSetupFieldsPanelTableFieldsTable } from "./Panels/Block17BSetupFieldsPanelTable/Block17BSetupFieldsPanelTable";
import { Block19PaidFieldsTableData } from "./Panels/Block19PaidFieldsTable/Block19PaidFieldsTable";
import { Divider } from "primereact/divider";
import FileSaver from "file-saver";
import { IAppState } from "../../store/reducers";
import { IDropDownListResponse } from "../../models/common/IDropDownListResponse";
import { IROERequestPayload } from "../../models/roe/IROERequestPayload";
import { ROEService } from "../../services/ROEService";
import { ROESetupToolbar } from "./ROESetupToolbar";
import { ROESetupValidationSchema } from "./validator";
import { ResourceDDLDataTableForSlips } from "../ResourceDDLDataTableForSlips";
import { T4SlipService } from "../../services/T4SlipService";
import { format } from "date-fns";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { setSelectedINVOICE } from "../../store/actions/invoiceReportActions";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IROESetup extends ITest { }

const SINGLE_RECORD_DATA_QUERY_KEY = "roe-single-data-record";
const CONTACT_PERSON_DDL_DATA_QUERY_KEY = "contact-person-ddl";
const DEFAULT_SETTINGS_DATA_QUERY_KEY = "default-settings-data-record";
const EMPLOYEE_DDL_DATA_QUERY_KEY = "employee-ddl-data-record";
const LOAD_DATA_QUERY_KEY = "roe-load-data";

const useGetData = (
  id: string | undefined,
  clientId: string,
  taxYear: number
) =>
  useQuery({
    queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id],
    queryFn: (data) => {
      return ROEService.getROEById(id, clientId, taxYear);
    },
    refetchOnWindowFocus: false,
  });
const useGetMaskStatus = () =>
  useQuery({
    queryKey: ["mask-status"],
    queryFn: (data) => {
      return AuthService.getMaskStatus();
    },
    refetchOnWindowFocus: false,
  });

const useGetContactPersonDDL = (clientId: string, taxYear: number) =>
  useQuery({
    queryKey: [CONTACT_PERSON_DDL_DATA_QUERY_KEY],
    queryFn: () => {
      return T4SlipService.getAllActiveContactPersonsByClientIdAndTaxYear(
        clientId,
        taxYear
      );
    },
    refetchOnWindowFocus: false,
  });

//   const useRoeGetLoadData = (
// 	runGetListAPICall:boolean,
// 	clientId: string,
// 	employeeId:string,
//   startDate: string | null,
//   endDate: string | null,
// ) =>
//   useQuery({
//     queryKey: [LOAD_DATA_QUERY_KEY, runGetListAPICall, clientId, employeeId, startDate, endDate],
//     queryFn: (data) => {
//       return ROEService.getROELoadData(runGetListAPICall, clientId, employeeId, startDate, endDate);
//     },
//     refetchOnWindowFocus: false,
//   });
export let block17COtherMoniesInitialData = [
  {
    id: "1",
    otherMonies: null,
    startDate: null,
    endDate: null,
    amount: null,
    addToBlock15bC: false,
  },
  {
    id: "2",
    otherMonies: null,
    startDate: null,
    endDate: null,
    amount: null,
    addToBlock15bC: false,
  },
  {
    id: "3",
    otherMonies: null,
    startDate: null,
    endDate: null,
    amount: null,
    addToBlock15bC: false,
  },
];

export let block19PaidFieldsTableInitialData = [
  {
    id: "1",
    paymentInformation: null,
    paymentStartDate: null,
    paymentEndDate: null,
    paymentAmount: null,
    paymentPeriod: null,
  },
];

export let block17BSetupFieldsPanelInitialData = [
  {
    id: "1",
    date: null,
    amount: null,
  },
];


const reasonForIssuringThisRoeDDL = [
  { value: "A00", label: "Shortage of work/End of contract or season" },
  { value: "A01", label: "Employer bankruptcy or receivership" },
  { value: "B00", label: "Strike or lockout" },
  { value: "D00", label: "Illness or injury" },
  { value: "E00", label: "Quit" },
  { value: "E02", label: "Quit/Follow spouse" },
  { value: "E03", label: "Quit/Return to school" },
  { value: "E04", label: "Quit/Health reasons" },
  { value: "E05", label: "Quit/Voluntary retirement" },
  { value: "E06", label: "Quit/Take another job" },
  { value: "E09", label: "Quit/Employer relocation" },
  { value: "E10", label: "Quit/Care for a dependant" },
  { value: "E11", label: "Quit/To become self-employed" },
  { value: "F00", label: "Maternity" },
  { value: "G00", label: "Mandatory retirement" },
  { value: "G07", label: "Retirement/Approved workforce reduction" },
  { value: "H00", label: "Work-Sharing" },
  { value: "J00", label: "Apprentice training" },
  { value: "K00", label: "Other" },
  { value: "K12", label: "Other/Change of payroll frequency" },
  { value: "K13", label: "Other/Change of ownership" },
  { value: "K14", label: "Other/Requested by Employment Insurance" },
  { value: "K15", label: "Other/Canadian Forces - Queen's Regulations/Orders" },
  { value: "K16", label: "Other/At the employee's request" },
  { value: "K17", label: "Other/Change of Service Provider" },
  { value: "M00", label: "Dismissal" },
  { value: "M08", label: "Dismissal/Terminated within probationary period" },
  { value: "N00", label: "Leave of absence" },
  { value: "P00", label: "Parental" },
  { value: "Z00", label: "Compassionate Care/Family Caregiver" },
];

const useGetEmployeeDDLItems = (clientId: string, taxYear: number) =>
  useQuery({
    queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, taxYear],
    queryFn: (data) => {
      return ROEService.getEmployeeDDL(clientId, taxYear);
    },
    refetchOnWindowFocus: false,
  });
const CLIENT_INFO_DATA_QUERY_KEY = "client-info-data-record";
const useGetClientInformationById = (
  id: string | undefined,
  navigateToLogout: (path: string) => void
) =>
  useQuery({
    queryKey: [CLIENT_INFO_DATA_QUERY_KEY, id, navigateToLogout],
    queryFn: (data) => {
      return ClientService.getSimpleClientById(id, navigateToLogout);
    },
    refetchOnWindowFocus: false,
  });
export const ROESetup: FC<IROESetup> = ({ testId }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigateToLogout = useNavigateToLogout();
  const clientName = useSelector((state: IAppState) => state.client.clientName);
  // const companyInfo = useSelector((state: IAppState) => state.dashboardApisData.client_detail);
  const isPendingActivityLogData = useSelector(
    (state: IAppState) => state.isLoadAxiosCall.isLoading
  );
  const isAdminUser = useSelector(
    (state: IAppState) => state.user.profile.isSuperStatus
  );
  const theme = useTheme();
  const [snackbarData, setSnackbarData] = useState<any>(INITIAL_SNACKBAR_DATA);
  const clientId = useSelector((state: IAppState) => state.client.id);
  const taxYear = useSelector((state: IAppState) => state.taxYear.year);
  const [isPendingSlipData, setIsPendingSlipData] = useState(false);
  const [isPendingSlipListDDL, setIsPendingSlipListDDL] = useState(false);
  const [selectedResource, setSelectedResource] = useState("create-new-roe");
  const [selectedResourceSlip, setSelectedResourceSlip] =
    useState("create-new-roe");
  const [selectedResourceSlipList, setSelectedResourceSlipList] = useState<
    IDropDownListResponse[]
  >([{ label: "Load Saved ROE", value: "create-new-roe" }]);

  const [selectedResourceList, setSelectedResourceList] = useState<
    IDropDownListResponse[]
  >([{ label: "Load Saved ROE", value: "create-new-roe" }]);
  const [resourceListWithoutCreateNew, setResourceListWithoutCreateNew] =
    useState<any>(undefined);

  const [onResourceSelectionAPIsCalls, setOnResourceSelectionAPIsCalls] =
    useState(false);

  // block17C

  const [block17COtherMoniesUpdatedData, setBlock17COtherMoniesUpdatedData] =
    useState(block17COtherMoniesInitialData);
  const [block17COtherMoniesDataItems, setBlock17COtherMoniesDataItems] =
    useState(block17COtherMoniesInitialData);

  // block17B

  const [Block17BSetupFieldsPanelTableUpdatedData, setBlock17BSetupFieldsPanelTableUpdatedData] =
    useState(block17BSetupFieldsPanelInitialData);
  const [Block17BSetupFieldsPanelTableDataItems, setBlock17BSetupFieldsPanelTableDataItems] =
    useState(block17BSetupFieldsPanelInitialData);

  // block19
  const [block19PaidFieldsTableUpdatedData, setblock19PaidFieldsTableUpdatedData] =
    useState(block19PaidFieldsTableInitialData);
  const [block19PaidFieldsDataItems, setBlock19PaidFieldsDataItems] =
    useState(block19PaidFieldsTableInitialData);

  const [editedResourceId, setEditedResourceId] = useState("");
  const [selectedOtherInformation, setSelectedOtherInformation] =
    useState(false);
  const [oiInEdit, setOiInEdit] = useState(false);
  // for delete row
  const [openDialog, setDialogOpen] = useState(false);
  const [apiAction, setApiAction] = useState("");
  const [singleDelete, setSingleDelete] = useState<boolean>(false);
  const [roeId, setROEId] = useState<any>("");
  const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
  const [ROERecord, setROERecord] = useState<any>(undefined);
  const [employeeDataById, setEmployeeDataById] = useState<any>(undefined);
  const [fields53For15c, setFields53For15c] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<any>(false);


  const [dateOfBirth, setDateOfBirth] = useState<any>("");



  // for edit
  const queryClient = useQueryClient();
  const { id } = useParams();

  const formMethods = useForm<any>({
    resolver: yupResolver(ROESetupValidationSchema),
    mode: "onBlur",
    reValidateMode: "onChange",
    // defaultValues: DEFAULT_VALUES,
  });

  // Function to sort the data array by the label field
  // sort side cards items
  const sortData = (data: IDropDownListResponse[]): IDropDownListResponse[] => {
    return data.sort((a, b) => a.label.localeCompare(b.label));
  };

  const { isPending: isPendingClientInformationById, data: companyInfo } = useGetClientInformationById(
    clientId,
    navigateToLogout
  );
  const { isPending: isSubmitting, mutate: submitROEFields } = useMutation({
    mutationFn: ROEService.create,

    onSuccess: (res: IROERequestPayload | IServerError | IResponse | any) => {

      if (res.data) {
        queryClient.invalidateQueries({
          queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, res.data.id],
        });

        formMethods.setValue("id", res.data.id);
        setSnackbarData({
          open: true,
          message: "Success",
          severity: "success",
        });
        scrollPanelFieldsToTop();
        // refectchROEIds();

        if (res.status === 201 && selectedResourceSlip === "create-new-roe") {
          (async () => {
            try {

              const response: any =
                await ROEService.getResourceRoeDropDownList(
                  res.data?.employeeId,
                  clientId,
                  taxYear
                );
              if (response && Array.isArray(response)) {
                let resourceSlipList: IDropDownListResponse[] = response.map(
                  (resourceSlip: IDropDownListResponse) => ({
                    label: resourceSlip.label,
                    value: resourceSlip.value,
                  })
                );

                resourceSlipList.unshift({
                  label: "Load Saved ROE",
                  value: "create-new-roe",
                });


                setSelectedResourceSlipList(resourceSlipList);
                setSelectedResourceSlip(
                  String(res.data.id)
                );
                scrollPanelFieldsToTop();
                let path = `/compliance/roe/setup/${res.data.id}`;
                navigate(path);
              }
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          })();
          setOnResourceSelectionAPIsCalls(true);
          setSelectedResourceSlip(res.data.id);
        }
      } else {
        setSnackbarData({
          open: true,
          message: res.message ? res.message : res.data.message,
          severity: "error",
        });
      }

      queryClient.invalidateQueries({
        queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, taxYear],
      });
      //load slip Data
      if (res && res.data && res.data?.resource) {
        setROERecord(res.data);
        setSelectedResource(res.data?.resource?.externalId);
      }
    },
    onError: (err: any) => {

      // TODO: customize the toast message based on the response
      setSnackbarData({
        open: true,
        // message: "Something went wrong, try again later!",
        message: err.message,
        severity: "error",
      });
    },
  });

  const createNewActionFromSlipDDL = () => {
    setROERecord(undefined);
    setSelectedResourceSlip("create-new-roe");
    setFields53For15c([])
    setBlock17COtherMoniesDataItems(block17COtherMoniesInitialData)
    setBlock19PaidFieldsDataItems(block19PaidFieldsTableInitialData)
    setBlock17BSetupFieldsPanelTableDataItems(block17BSetupFieldsPanelInitialData)

  };

  // resourceDataById in function
  // const resourceDataByIdPass = useCallback(
  //   (resourceDataById: any) => {

  //     setIsPendingSlipData(true);
  //     if (resourceDataById) {
  //       Object.keys(resourceDataById).forEach((fieldName) => {
  //         const fieldValue = resourceDataById[fieldName];

  //         // formMethods.setValue(
  //         //   fieldName,
  //         //   fieldValue !== null && fieldValue !== "" ? fieldValue : ""
  //         // );
  //       });
  //       createNewActionFromSlipDDL();
  //       setIsPendingSlipData(false);
  //     }
  //   },
  //   [onResourceSelectionAPIsCalls]
  // );

  // slipDataById in function
  const slipDataByIdPass = useCallback(
    (slipDataById: any, onResourceSelectionAPIsCalls: boolean) => {
      setIsPendingSlipData(true);
      if (slipDataById) {
        Object.keys(slipDataById).forEach((fieldName) => {
          const fieldValue = slipDataById[fieldName];

          if (fieldName !== "startDate" && fieldName !== "endDate" && typeof fieldValue !== "object") {
            formMethods.setValue(fieldName, fieldValue);
          }

          if (fieldName === "endDate") {
            const previousEndDate = new Date(slipDataById.endDate);
            const nextDayFromPreviousEndDate = new Date(previousEndDate);
            nextDayFromPreviousEndDate.setDate(previousEndDate.getDate() + 1);
            const nextDay = nextDayFromPreviousEndDate
              .toISOString()
              .split("T")[0];

            const startDate = new Date(nextDay);
            formMethods.setValue("startDate", startDate);
            const currentDate = new Date();
            formMethods.setValue("endDate", currentDate);
          }
          if (fieldName === 'expectedDateOfRecallDate' && fieldValue && fieldValue !== null) {
            const date = new Date(fieldValue)
            formMethods.setValue(fieldName, date);
          }
          if (fieldName === 'expectedDateOfRecall' && fieldValue && fieldValue !== null) {
            setExpectDateOfRecall(Number(fieldValue));
            formMethods.setValue(fieldName, fieldValue);
          }

          if (fieldName === 'vacationPayDescription') {
            Object.keys(fieldValue).forEach((vacationPayFieldName: string) => {
              const vacationPayFieldValue = fieldValue[vacationPayFieldName]
              formMethods.setValue(vacationPayFieldName, vacationPayFieldValue);
              if (vacationPayFieldName === 'endDateBlock17A' && vacationPayFieldValue && vacationPayFieldValue !== null) {
                const date = new Date(vacationPayFieldValue)
                formMethods.setValue(vacationPayFieldName, date);
              }
              if (vacationPayFieldName === 'startDateBlock17A' && vacationPayFieldValue && vacationPayFieldValue !== null) {
                const date = new Date(vacationPayFieldValue)
                formMethods.setValue(vacationPayFieldName, date);
              }

              if (vacationPayFieldName === 'description') {
                formMethods.setValue(
                  vacationPayFieldName,
                  Number(vacationPayFieldValue)
                );
              }
            });
          }

          if (fieldName === "otherMonies" && Array.isArray(fieldValue)) {
            const formattedOtherMonies = fieldValue.map((item: any) => ({
              ...item,
              startDate: item.startDate ? new Date(item.startDate) : null,
              endDate: item.endDate ? new Date(item.endDate) : null,
            }));

            setBlock17COtherMoniesDataItems(formattedOtherMonies);
            setBlock17COtherMoniesUpdatedData(formattedOtherMonies);
          }

          // Block 19 Paid 
          if (fieldName === "paymentInformation" && Array.isArray(fieldValue)) {
            const formattedBlock19PaidFields = fieldValue.map((item: any) => ({
              ...item,
              paymentStartDate: item.paymentStartDate ? new Date(item.paymentStartDate) : null,
              paymentEndDate: item.paymentEndDate ? new Date(item.paymentEndDate) : null,
            }));

            setBlock19PaidFieldsDataItems(formattedBlock19PaidFields);
            setblock19PaidFieldsTableUpdatedData(formattedBlock19PaidFields);
          }


          // if (fieldName === 'paymentInformation') {
          //   Object.keys(fieldValue).forEach((paymentInformationFieldName: string) => {
          //     const paymentInformationFieldValue = fieldValue[paymentInformationFieldName]
          //     formMethods.setValue(paymentInformationFieldName, paymentInformationFieldValue);
          //     if (paymentInformationFieldName === 'paymentStartDate' && paymentInformationFieldValue && paymentInformationFieldValue !== null) {
          //       const date = new Date(paymentInformationFieldValue)
          //       formMethods.setValue(paymentInformationFieldName, date);
          //     }
          //     if (paymentInformationFieldName === 'paymentEndDate' && paymentInformationFieldValue && paymentInformationFieldValue !== null) {
          //       const date = new Date(paymentInformationFieldValue)
          //       formMethods.setValue(paymentInformationFieldName, date);
          //     }
          //   });
          // }
          // if (fieldName === 'statutoryHoliday') {
          //   Object.keys(fieldValue).forEach((statutoryHolidayFieldName: string) => {
          //     const statutoryHolidayFieldValue = fieldValue[statutoryHolidayFieldName]
          //     formMethods.setValue(statutoryHolidayFieldName, statutoryHolidayFieldValue);
          //     if (statutoryHolidayFieldName === 'dateBlock16B1' && statutoryHolidayFieldValue && statutoryHolidayFieldValue !== null
          //     ) {
          //       const date = new Date(statutoryHolidayFieldValue)
          //       formMethods.setValue(statutoryHolidayFieldName, date);
          //     }
          //     if (
          //       statutoryHolidayFieldName === 'dateBlock16B2' && statutoryHolidayFieldValue && statutoryHolidayFieldValue !== null
          //     ) {
          //       const date = new Date(statutoryHolidayFieldValue)
          //       formMethods.setValue(statutoryHolidayFieldName, date);
          //     }
          //     if (
          //       statutoryHolidayFieldName === 'dateBlock16B3' && statutoryHolidayFieldValue && statutoryHolidayFieldValue !== null
          //     ) {
          //       const date = new Date(statutoryHolidayFieldValue)
          //       formMethods.setValue(statutoryHolidayFieldName, date);
          //     }
          //     if (
          //       statutoryHolidayFieldName === 'dateBlock16B4' && statutoryHolidayFieldValue && statutoryHolidayFieldValue !== null
          //     ) {
          //       const date = new Date(statutoryHolidayFieldValue)
          //       formMethods.setValue(statutoryHolidayFieldName, date);
          //     }
          //     if (
          //       statutoryHolidayFieldName === 'dateBlock16B5' && statutoryHolidayFieldValue && statutoryHolidayFieldValue !== null
          //     ) {
          //       const date = new Date(statutoryHolidayFieldValue)
          //       formMethods.setValue(statutoryHolidayFieldName, date);
          //     }
          //     if (
          //       statutoryHolidayFieldName === 'dateBlock16B6' && statutoryHolidayFieldValue && statutoryHolidayFieldValue !== null
          //     ) {
          //       const date = new Date(statutoryHolidayFieldValue)
          //       formMethods.setValue(statutoryHolidayFieldName, date);
          //     }
          //     if (
          //       statutoryHolidayFieldName === 'dateBlock16B7' && statutoryHolidayFieldValue && statutoryHolidayFieldValue !== null
          //     ) {
          //       const date = new Date(statutoryHolidayFieldValue)
          //       formMethods.setValue(statutoryHolidayFieldName, date);
          //     }
          //     if (
          //       statutoryHolidayFieldName === 'dateBlock16B8' && statutoryHolidayFieldValue && statutoryHolidayFieldValue !== null
          //     ) {
          //       const date = new Date(statutoryHolidayFieldValue)
          //       formMethods.setValue(statutoryHolidayFieldName, date);
          //     }
          //     if (
          //       statutoryHolidayFieldName === 'dateBlock16B9' && statutoryHolidayFieldValue && statutoryHolidayFieldValue !== null
          //     ) {
          //       const date = new Date(statutoryHolidayFieldValue)
          //       formMethods.setValue(statutoryHolidayFieldName, date);
          //     }
          //     if (
          //       statutoryHolidayFieldName === 'dateBlock16B10' && statutoryHolidayFieldValue && statutoryHolidayFieldValue !== null
          //     ) {
          //       const date = new Date(statutoryHolidayFieldValue)
          //       formMethods.setValue(statutoryHolidayFieldName, date);
          //     }
          //   });
          // }
          // if (fieldName === 'statutoryHoliday') {
          //   setBlock17BSetupFieldsPanelTableUpdatedData(fieldValue)
          // }

          if (fieldName === "statutoryHoliday" && Array.isArray(fieldValue)) {
            const formattedblock17BSetupFields = fieldValue.map((item: any) => ({
              ...item,
              date: item.date ? new Date(item.date) : null,
            }));

            setBlock17BSetupFieldsPanelTableDataItems(formattedblock17BSetupFields);
            setBlock17BSetupFieldsPanelTableUpdatedData(formattedblock17BSetupFields);
          }

          if (fieldName === 'fields53For15c') {
            setFields53For15c(fieldValue)
          }
          if (fieldName === 'id') {
            setSelectedResourceSlip(fieldValue);
            let path = `/compliance/roe/setup/${fieldValue}`;
            navigate(path);
          }

          if (fieldName === "employeeId") {
            setSelectedEmployee(String(fieldValue));
            setSelectedResource(fieldValue);
            setEditedResourceId(fieldValue);
            if (!onResourceSelectionAPIsCalls) {
              (async () => {
                try {
                  const response =
                    await ROEService.getResourceRoeDropDownList(
                      fieldValue,
                      clientId,
                      taxYear
                    );
                  if (Array.isArray(response)) {
                    const resourceSlipList = [
                      { label: "Create New", value: "create-new" },
                      ...response.map((r) => ({
                        label: r.label,
                        value: r.value,
                      })),
                    ];
                    setSelectedResourceSlipList(resourceSlipList);
                  }
                } catch (err) {
                  console.error("Error fetching resource slips", err);
                }
              })();
            }
          }
        });
      }
    },
    []
  );

  // for edit

  //for that slips which are completed
  const { isPending: isPendingData, data: selectedROEData } = useGetData(
    id,
    clientId,
    taxYear
  );

  const { isPending: isPendingEmployeeDDLItems, data: employeeDDLItems } =
    useGetEmployeeDDLItems(clientId, taxYear);

  const { isPending: isPendingMaskStatus, data: maskStatus } =
    useGetMaskStatus();

  const { isPending: isPendingContactPersonDDL, data: contactPersonDDL } =
    useGetContactPersonDDL(clientId, taxYear);


  useEffect(() => {
    if (employeeDDLItems) {
      if (employeeDDLItems && Array.isArray(employeeDDLItems)) {
        let resources: IDropDownListResponse[] = sortDDLByLabel(employeeDDLItems).map(
          (resourceItem: IDropDownListResponse) => ({
            // id: resourceItem.id,
            label: resourceItem.label,
            value: resourceItem.value,
          })
        );

        resources.unshift({
          label: "Load Saved ROE",
          value: "create-new-roe",
        });

        setSelectedResourceList(resources);
      }
      setResourceListWithoutCreateNew(sortData(employeeDDLItems));
    }
  }, [employeeDDLItems]);

  useEffect(() => {
    if (id && selectedROEData) {
      setROERecord(selectedROEData);
    }
  }, [id && selectedROEData]);




  const validateROEData = (requestPayload: any) => {
    const errors: string[] = [];

    // ✅ Validate Statutory Holidays (Block 17-B)
    // for (let i = 1; i <= 10; i++) {
    //   const date = requestPayload["statutoryHoliday"][`dateBlock16B${i}`];
    //   const amount = requestPayload["statutoryHoliday"][`amountBlock16B${i}`];


    //   if (date && (!amount && amount === null || amount === "")) {
    //     errors.push(
    //       `Amount in Statutory Holiday ${i} is required, because corresponding date in Statutory Holiday ${i} is provided.`
    //     );
    //   }

    //   if ((date === null || date === "") && amount) {
    //     errors.push(
    //       `Date in Statutory Holiday ${i} is required, because corresponding amount in Statutory Holiday ${i} is provided.`
    //     );
    //   }
    // }

    for (let i = 1; i <= 10; i++) {
      const date = requestPayload["statutoryHoliday"][`dateBlock16B${i}`];
      const amount = requestPayload["statutoryHoliday"][`amountBlock16B${i}`];



      const hasDate = date !== null && date !== "" && date !== undefined;
      const hasAmount =
        amount !== null && amount !== "" && amount !== undefined;

      // Case 1: Date provided but amount missing
      if (hasDate && !hasAmount) {
        errors.push(
          `Amount in Statutory Holiday ${i} is required, because corresponding date in Statutory Holiday ${i} is provided.`
        );
      }

      // Case 2: Amount provided but date missing
      if (!hasDate && hasAmount) {
        errors.push(
          `Date in Statutory Holiday ${i} is required, because corresponding amount in Statutory Holiday ${i} is provided.`
        );
      }
    }

    // ✅ Validate Other Monies (Block 17-C)
    requestPayload.otherMonies.forEach((item: any, index: number) => {
      const idx = index + 1;

      if (item.otherMonies && (item.amount === null || item.amount === "")) {
        errors.push(
          `Other monies amount ${idx} is required in Block 17C, because a value is selected in corresponding Other monies code ${idx}.`
        );
      }

      if (!item.otherMonies && item.amount) {
        errors.push(
          `Other monies Code ${idx} is required in Block 17C, because Other monies amount ${idx} is entered.`
        );
      }
    });

    // ✅ Final Output
    if (errors.length > 0) {
      errors.forEach((err) =>
        setSnackbarData({
          open: true,
          message: err,
          severity: "error",
        })
      );
    } else {
      // alert("All OK ✅");
      submitROEFields(requestPayload);
    }
  };

  const { watch } = formMethods;


  const values = watch([
    "startDate",
    "endDate"
  ]);

  const [startDate, endDate] = values;

  const onSubmit = async (formData: any) => {
    console.log('formDAta', formData)

    if (selectedEmployee !== null) {


      const formatDatesBlock17COtherMoniesUpdatedData =
        block17COtherMoniesUpdatedData.map((x: any) => ({
          ...x,
          startDate: formatDate(x.startDate),
          endDate: formatDate(x.endDate),
        }));
      const formatblock17BSetupFieldsPanelTableFieldsTable =
        Block17BSetupFieldsPanelTableUpdatedData?.map((x: any) => ({
          ...x,
          date: x.date ? formatDate(x.date) : undefined,
          amount: x.amount ? x.amount : undefined,
          id: undefined
          // amount:x.amount

        }));

      // block 19 Paid
      const formatDatesBlock19PaidFieldsUpdatedData =
        block19PaidFieldsTableUpdatedData && block19PaidFieldsTableUpdatedData.map((x: any) => ({
          ...x,
          paymentStartDate: formatDate(x.paymentStartDate),
          paymentEndDate: formatDate(x.paymentEndDate),
        }));


      const generateBlock15CCompleteAccordingToChart = (
        data: any
      ): { id: number; value: any }[] => {
        return Object.entries(data)
          .filter(([key]) => {
            const numKey = Number(key);
            return !isNaN(numKey) && numKey >= 1 && numKey <= 53;
          })
          .map(([key, value]) => ({
            id: Number(key),
            value,
          }));
      };

      const requestPayload: any = {
        clientId: clientId,
        taxYear: taxYear,
        id:
          selectedROEData && selectedROEData.resource
            ? selectedROEData.id
            : ROERecord && ROERecord.id
              ? ROERecord.id
              : undefined,

        employeeId: selectedEmployee,

        // employee info
        // firstDayWorked: formatDate(startDate),
        // lastDayWorked: formatDate(endDate),
        // finalPayperiodEndDate:
        // firstName: employeeDataById && employeeDataById.firstName,
        // lastName: employeeDataById && employeeDataById.lastName,
        // initial: employeeDataById && employeeDataById.initial,
        // address: employeeDataById && employeeDataById.address.addressLine1,
        // city: employeeDataById && employeeDataById.address.city,
        // province: employeeDataById && employeeDataById.address.province,
        // postCode: employeeDataById && employeeDataById.address.postCode,
        // payPeriodType: employeeDataById && employeeDataById.employeePayroll.payFrequency,
        // socialInsuranceNo: employeeDataById && employeeDataById.socialInsuranceNumber,

        // Header
        startDate: formatDate(formData.startDate),
        endDate: formatDate(formData.endDate),

        // Block-2
        serialNoOfRoeAmendedOrReplaced:
          formData.serialNoOfRoeAmendedOrReplaced !== ""
            ? formData.serialNoOfRoeAmendedOrReplaced
            : null,

        // Block-3
        // employerPayrollReferenceNo: formData.employerPayrollReferenceNo,

        // Block-13
        occupation: formData.occupation,

        // Block-14
        expectedDateOfRecall: Number(formData.expectedDateOfRecall),
        expectedDateOfRecallDate: formatDate(formData.expectedDateOfRecallDate),

        // Block 15-A
        totalInsurableHoursAccordingToChart:
          formData.totalInsurableHoursAccordingToChart,

        // Block 15-B
        totalInsurableEarningAccordingToChart:
          formData.totalInsurableEarningAccordingToChart,

        // Block 15-C
        fields53For15c: generateBlock15CCompleteAccordingToChart(formData),


        // Block-16
        reasonForIssuringThisRoe: formData.reasonForIssuringThisRoe,
        contactPerson: formData.contactPerson,

        // Block 17-A
        vacationPayDescription: {
          description: formData.description,
          startDateBlock17A: formatDate(formData.startDateBlock17A),
          endDateBlock17A: formatDate(formData.endDateBlock17A),
          block17AAmount: formData.block17AAmount,
          addToBlock15bC: formData.addToBlock15bC,
        },

        // Block 17-B
        statutoryHoliday: formatblock17BSetupFieldsPanelTableFieldsTable,

        // // Block 17-B
        // statutoryHoliday: {
        //   dateBlock16B1:
        //     formData.dateBlock16B1 && formatDate(formData.dateBlock16B1),
        //   amountBlock16B1: formData.amountBlock16B1,
        //   dateBlock16B2:
        //     formData.dateBlock16B2 && formatDate(formData.dateBlock16B2),
        //   amountBlock16B2: formData.amountBlock16B2,
        //   dateBlock16B3:
        //     formData.dateBlock16B3 && formatDate(formData.dateBlock16B3),
        //   amountBlock16B3: formData.amountBlock16B3,
        //   dateBlock16B4:
        //     formData.dateBlock16B4 && formatDate(formData.dateBlock16B4),
        //   amountBlock16B4: formData.amountBlock16B4,
        //   dateBlock16B5:
        //     formData.dateBlock16B5 && formatDate(formData.dateBlock16B5),
        //   amountBlock16B5: formData.amountBlock16B5,
        //   dateBlock16B6:
        //     formData.dateBlock16B6 && formatDate(formData.dateBlock16B6),
        //   amountBlock16B6: formData.amountBlock16B6,
        //   dateBlock16B7:
        //     formData.dateBlock16B7 && formatDate(formData.dateBlock16B7),
        //   amountBlock16B7: formData.amountBlock16B7,
        //   dateBlock16B8:
        //     formData.dateBlock16B8 && formatDate(formData.dateBlock16B8),
        //   amountBlock16B8: formData.amountBlock16B8,
        //   dateBlock16B9:
        //     formData.dateBlock16B9 && formatDate(formData.dateBlock16B9),
        //   amountBlock16B9: formData.amountBlock16B9,
        //   dateBlock16B10:
        //     formData.dateBlock16B10 && formatDate(formData.dateBlock16B10),
        //   amountBlock16B10: formData.amountBlock16B10,
        // },

        // Block 17-C
        otherMonies: formatDatesBlock17COtherMoniesUpdatedData,

        // Block-18
        comments: formData.comments,

        // block 19 paid
        paymentInformation: formatDatesBlock19PaidFieldsUpdatedData,

        // Block-19
        // paymentInformation: {
        //   paymentType: formData.paymentType,
        //   paymentStartDate: formData.paymentStartDate && formatDate(formData.paymentStartDate),
        //   paymentEndDate: formData.paymentEndDate && formatDate(formData.paymentEndDate),
        //   paymentAmount: formData.paymentAmount,
        //   paymentPeriod: formData.paymentPeriod,
        // },

        // Block-20
        communicationPrefferedIn: formData.communicationPrefferedIn ? Number(formData.communicationPrefferedIn) : 100,
      };
      validateROEData(requestPayload);

      // submitROEFields(requestPayload);
    } else {
      setSnackbarData({
        open: true,
        message: "Please Select Employee!",
        severity: "error",
      });
    }
  };

  const onResetClicked = () => {
    setSnackbarData({
      open: true,
      message: "Success",
      severity: "success",
    });
    formMethods.reset();
    createNewActionFromSlipDDL()
    setSelectedResourceSlipList([
      { label: "Load Saved ROE", value: "create-new-roe" },
    ]);
    setSelectedResourceSlip("create-new-roe");
    setSelectedOtherInformation(false);
    setSelectedResource("create-new-roe");
    setSelectedEmployee(null);
    scrollPanelFieldsToTop();
    let path = `/compliance/roe/setup`;
    navigate(path);
    setROERecord(undefined);
  };

  // For Delete Row

  const { isPending: isDeleting, mutate: deleteROEById } = useMutation({
    mutationFn: ROEService.delROE,

    onSuccess: (res: any | IServerError | IResponse) => {

      if (typeof res === "string") {
        // remove the cache of the Year fields since we just added a new field.
        setSnackbarData({
          open: true,
          message: "Success",
          severity: "success",
        });
        setROERecord(undefined);
        scrollPanelFieldsToTop();
      } else {
        setSnackbarData({
          open: true,
          // message: "Something went wrong, try again later!",
          message: res.message,
          severity: "error",
        });
      }

      //load Employee Data
      if (res) {
        const selectedEmployee = formMethods.getValues("selectedEmployee");

        if (selectedEmployee !== "create-new-roe") {
          let path = `/compliance/roe/setup/${selectedEmployee}`;
          navigate(path);
          const fetchData = async () => {
            try {
              const response: any =
                await ROEService.getResourceRoeDropDownList(
                  selectedEmployee,
                  clientId,
                  taxYear
                );

              if (response && Array.isArray(response)) {
                let resourceSlipList: IDropDownListResponse[] = response.map(
                  (resourceSlip: IDropDownListResponse) => ({
                    label: resourceSlip.label,
                    value: resourceSlip.value,
                  })
                );

                resourceSlipList.unshift({
                  label: "Load Saved ROE",
                  value: "create-new-roe",
                });


                setSelectedResourceSlipList(resourceSlipList);
                setSelectedResourceSlip(
                  String(resourceSlipList[0].value)
                );
                createNewActionFromSlipDDL();
              }
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          };

          fetchData();
        }
      }
    },
    onError: (err: any) => {
      setSnackbarData({
        open: true,
        message: err.message,
        severity: "error",
      });
    },
  });

  const deleteROEField = () => {
    if (singleDelete) {
      let payload = {
        roeId,
        clientId,
        taxYear,
      };
      setSingleDelete(false);
      deleteROEById(payload);
      setDialogOpen(false);
    }
  };

  const onDeleteClicked = () => {
    setDialogOpen(true);
    setSingleDelete(true);
    setApiAction("delete");
    if (
      selectedROEData &&
      selectedROEData.resource
      // && editedRecordSlipCreateNew === false
    ) {
      setROEId(selectedROEData.id);
    }
  };

  const onClickInvoiceNoHandler = (clickedRow: any) => {
    dispatch(setSelectedINVOICE(clickedRow));

  };
  /**
   * On Snackbar closed.
   *
   * @param {React.SyntheticEvent | Event} event
   * @param {string} reason
   */
  const onSnackbarClosed = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarData(INITIAL_SNACKBAR_DATA);
  };

  const onResourceSelectionChangeHandler = async (
    selectedItem: IEnhancedDropDownItem | any
  ): Promise<void> => {
    formMethods.reset();
    setOnResourceSelectionAPIsCalls(true);
    (async () => {
      try {
        setIsPendingSlipData(true);
        let resourceDataById = await ROEService.getResourceInformationById(
          selectedItem.value,
          clientId,
          "Employee"
        );

        setEmployeeDataById(resourceDataById)
        if (resourceDataById) {
          Object.keys(resourceDataById).forEach((fieldName) => {
            // @ts-ignore
            const fieldValue = resourceDataById[fieldName];
            if (fieldName === "id") {
              setSelectedEmployee(String(fieldValue));
              (async () => {
                try {
                  const response: any =
                    await ROEService.getResourceRoeDropDownList(
                      fieldValue,
                      clientId,
                      taxYear
                    );
                  if (response && Array.isArray(response)) {
                    let resourceSlipList: IDropDownListResponse[] =
                      response.map((resourceSlip: IDropDownListResponse) => ({
                        label: resourceSlip.label,
                        value: resourceSlip.value,
                      }));

                    resourceSlipList.unshift({
                      label: "Load Saved ROE",
                      value: "create-new-roe",
                    });


                    setSelectedResourceSlipList(resourceSlipList);
                    if (resourceSlipList && resourceSlipList.length > 1) {
                      (async () => {
                        try {

                          let slipDataById = await ROEService.getROEById(
                            String(resourceSlipList[1].value),
                            clientId,
                            taxYear
                          );
                          // const previousEndDate = new Date('2025-08-31');
                          const previousEndDate = new Date(
                            slipDataById.endDate
                          );
                          const nextDayFromPreviousEndDate = new Date(
                            previousEndDate
                          );
                          nextDayFromPreviousEndDate.setDate(
                            previousEndDate.getDate() + 1
                          );
                          const nextDay = nextDayFromPreviousEndDate
                            .toISOString()
                            .split("T")[0];

                          const startDate = new Date(nextDay);
                          formMethods.setValue("startDate", startDate);
                          const currentDate = new Date();
                          formMethods.setValue("endDate", currentDate);

                          setROERecord(slipDataById);
                          setSelectedResourceSlip(
                            String(resourceSlipList[1].value)
                          );

                          slipDataByIdPass(slipDataById, true);
                        } catch (error) {
                          setIsPendingSlipData(false);
                          console.error("Error fetching data:", error);
                        } finally {
                          setIsPendingSlipData(false);
                        }
                      })();
                    } else {
                      // formMethods.reset();
                      const startDate = new Date(
                        resourceDataById.employeePayroll.dateOfHire
                      );
                      formMethods.setValue("startDate", startDate);
                      const currentDate = new Date();
                      formMethods.setValue("endDate", currentDate);

                      createNewActionFromSlipDDL()
                      // resourceDataByIdPass(resourceDataById);
                      setSelectedResource(String(selectedItem.value));
                      setEditedResourceId(String(selectedItem.value));
                      let path = `/compliance/roe/setup/${selectedItem.value}`;
                      navigate(path);
                      setIsPendingSlipData(false);
                    }
                  }
                } catch (error) {
                  console.error("Error fetching data:", error);
                }
              })();
              setSelectedResource(fieldValue);
            }
          });
        }
      } catch (error) {
        setIsPendingSlipData(false);
        console.error("Error fetching data:", error);
      }
    })();
  };

  const onResourceSlipSelectionChangeHandler = (
    selectedItem: IEnhancedDropDownItem | any
  ) => {

    setOnResourceSelectionAPIsCalls(true);
    if (selectedItem.value === "create-new-roe") {
      createNewActionFromSlipDDL();
      setROERecord(undefined);
      setSelectedResourceSlip("create-new-roe");
      if (selectedResource !== "create-new-roe") {
        setOnResourceSelectionAPIsCalls(false);
        // let path = `/compliance/roe/setup/${selectedResource}`;
        // navigate(path);
      }
    }
    if (selectedItem.value !== "create-new-roe") {
      (async () => {
        try {
          setIsPendingSlipData(true);
          let slipDataById = await ROEService.getROEById(
            String(selectedItem.value),
            clientId,
            taxYear
          );
          setROERecord(slipDataById);

          // slipDataByIdPass(slipDataById, true);
          setIsPendingSlipData(false);
        } catch (error) {
          setIsPendingSlipData(false);
          console.error("Error fetching data:", error);
        }
      })();
    }
  };

  // // for edit
  useEffect(() => {

    if (ROERecord && onResourceSelectionAPIsCalls === false) {
      slipDataByIdPass(ROERecord, onResourceSelectionAPIsCalls);
      setIsPendingSlipData(false);
      let employeeDataToShow = {
        id: ROERecord.employeeId,
        socialInsuranceNumber: ROERecord.socialInsuranceNo,
        firstName: ROERecord.firstName,
        lastName: ROERecord.lastName,
        address: {
          addressLine1: ROERecord.address,
          city: ROERecord.city,
          postCode: ROERecord.postCode,
          province: {
            shortCode: ROERecord.province?.shortCode
          },
        }
      }
      setEmployeeDataById(employeeDataToShow)
    }
  }, [
    ROERecord,
    formMethods.setValue,
    formMethods,
    id,
    onResourceSelectionAPIsCalls,
  ]);

  const onCloseHandler = () => {
    setDialogOpen(false);
  };

  const tableScrollRef = useRef<HTMLDivElement>(null);
  const upadtedEmployeeDDLListItems = useMemo(() => {
    return (
      resourceListWithoutCreateNew &&
      sortDDLByLabel(resourceListWithoutCreateNew).map((item: any) => ({
        ...item,
        label: (
          <span
            style={{ color: theme.palette.primary.light, cursor: "pointer" }}
            onClick={() => {
              onResourceSelectionChangeHandler(item)
              scrollPanelFieldsToTop();
            }}
          >
            {item.label}
          </span>
        ),
      }))
    );
  }, [resourceListWithoutCreateNew]);

  const [expectedDateOfRecall, setExpectDateOfRecall] = useState(200);
  const onExpectDateOfRecallChangeHandler = (option: any) => {
    let selectedOption = option.target.value;
    setExpectDateOfRecall(Number(selectedOption));

    if (selectedOption !== 100) {
      formMethods.setValue('expectedDateOfRecallDate', undefined)
    }
  };


  const drawerMenuOptions = useSelector(
    (state: IAppState) => state.drawerMenu.menu
  );

  const expandedLabels = ["Compliance", "ROE"];
  const expandedROESetupItem = "Create";
  const enhanceData = (data: any[], parentLabel?: string): any[] => {
    return data.map((item) => {
      let isExpanded = expandedLabels.includes(item.label);
      if (parentLabel === "ROE" && item.label === expandedROESetupItem) {
        isExpanded = true;
      }
      const enhancedItem = {
        ...item,
        expanded: item.items ? isExpanded : false,
        items: item.items ? enhanceData(item.items, item.label) : undefined,
        path: item.label === expandedROESetupItem && "/compliance/roe/setup",
      };
      return enhancedItem;
    });
  };

  useEffect(() => {
    dispatch(setSelectedStickyNavBar({ isSticky: true }));
    if (drawerMenuOptions && drawerMenuOptions.length > 0) {
      const enhancedData = enhanceData(drawerMenuOptions);
      dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
    }
  }, [drawerMenuOptions]);

  // const onLoadButtonClickedHandler = () => {
  //   alert("Load Button Conditions will applies very soon!");
  // };
  const onLoadButtonClickedHandler = (
  ) => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const response: any = await ROEService.getROELoadData(
          clientId,
          selectedEmployee,
          formatDate(startDate),
          formatDate(endDate),
        );
        if (response) {
          setROERecord(response)
        }
      } catch {
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  };


  // const saveXmlAsFile = (xmlData: any, filename: any) => {
  //   const blob = new Blob([xmlData], { type: "xml;charset=utf-8" });
  //   FileSaver.saveAs(blob, filename);
  // };

  // const onGenerateROEXMLClicked = async (): Promise<void> => {
  //     // setIsLoading(true);
  //     // if (maskedStatus === "true") {
  //     //   setIsLoading(false);
  //     //   setSnackbarData({
  //     //     open: true,
  //     //     message: "Please unmask your data.",
  //     //     severity: "error",
  //     //   });
  //     // } 
  //     // else {
  //       setIsLoading(true);
  //       try {
  //         const response: any = await ROEService.createROEXml(
  //           clientId,
  //           selectedEmployee,
  //         "Ahmad",
  //         "bkl"


  //         );
  //         if (response.status === 400) {
  //           setSnackbarData({
  //             open: true,
  //             message: response.data.message
  //               ? response.data.message
  //               : "Something went wrong.",
  //             severity: "error",
  //           });
  //         } else {
  //           const filename = `ROE-${clientName}.xml`;
  //           saveXmlAsFile(response, filename);
  //         }
  //         setIsLoading(false);
  //       } catch (err) {

  //         alert(err);
  //       } finally {
  //         setIsLoading(false);
  //       }
  //     // }
  //   };

  const contactPersonPhoneNumberSelection = watch("contactPerson");
  const contactPersonPhoneNumber =
    contactPersonDDL && !contactPersonDDL.message && contactPersonDDL?.find(
      (x: any) => x.value === contactPersonPhoneNumberSelection
    )?.phoneNo;

  return (
    <>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <BackdropCircularProgress
          open={
            isPendingEmployeeDDLItems ||
            isSubmitting ||
            isPendingData ||
            isPendingSlipData ||
            isPendingSlipListDDL ||
            isDeleting ||
            isPendingActivityLogData ||
            isLoading || isPendingContactPersonDDL || isPendingClientInformationById
          }
          testId={testId}
        />
        <DeleteConfirmationDialog
          open={openDialog}
          deleteActionHandler={deleteROEField}
          cancelActionHandler={onCloseHandler}
          testId="T4-confirmation-dialog"
        />
        <FormProvider {...formMethods}>
          <form onSubmit={formMethods.handleSubmit(onSubmit)}>
            <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <Grid
                size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
                sx={{
                  borderRadius: "3px",
                }}
              >
                <ROESetupToolbar
                  // onGenerateROEXMLClicked={onGenerateROEXMLClicked}
                  onResetClicked={onResetClicked}
                  // onDeleteClicked={onDeleteClicked}
                  isSubmitting={false}
                  formMethods={formMethods}
                  pageTitle="ROE Setup"
                  selectedEmployee={selectedEmployee}
                />
                <TopRowTwoColumnLayout
                  showToolbar={false}
                  topRowContent={
                    <StandardPanel
                      title="Block - 2 Serial No. of ROE Amended or Replaced"
                      testId={`${testId}-slip-data`}
                      showTitle={false}
                    // topPadding={7.6}  // this padding add when submit appbar position is fixed
                    >
                      <Grid
                        container
                        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                        sx={
                          {
                            // background: "#fff",
                            // border: "1px solid #e5e7eb",
                            // borderBottom: 0,
                            // borderRadius: "2px 2px 0 0",
                            // padding: "31px 5px 0 5px",
                            // marginTop:"5rem"
                          }
                        }
                      >
                        <Grid
                          size={{ xs: 12, sm: 4, md: 3.3, lg: 3.3, xl: 3.3 }}
                        // sx={{ mt: "12px" }}
                        >
                          <RHookFormDatePicker
                            name="startDate"
                            testId="startDate"
                            label="Start Date"
                            labelPosition={LabelPosition.Top}
                            format="M dd, yy"
                          />
                          <RHookFormDatePicker
                            name="endDate"
                            testId="endDate"
                            label="End Date"
                            labelPosition={LabelPosition.Top}
                            format="M dd, yy"
                          />
                        </Grid>
                        <Grid
                          size={{ xs: 0, sm: 0, md: 0.3, lg: 0.3, xl: 0.3 }}
                        ></Grid>
                        <Grid
                          size={{ xs: 12, sm: 3, md: 1.7, lg: 1.7, xl: 1.7 }}
                          sx={{
                            color: "rgba(0, 0, 0, 0.6)",
                            fontSize: "0.875rem",
                            paddingTop: "6px",
                          }}
                        >
                          Employee ID: 10
                          <br />
                          Custom ID A-223
                          <br />
                          Accrued Vacation Pay 80.00 <br />
                          ROE Created
                        </Grid>
                        <Grid
                          size={{ xs: 0, sm: 0, md: 0.3, lg: 0.3, xl: 0.3 }}
                        ></Grid>
                        <Grid
                          size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}
                          sx={{
                            color: "rgba(0, 0, 0, 0.6)",
                            fontSize: "0.875rem",
                            paddingTop: "6px",
                          }}
                        >
                          Max Pay Period Required (Insurable Hours 27)
                          <br />
                          Max Pay Period Required (Insurable Earnings 14)
                        </Grid>
                        <Grid
                          size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}
                          sx={{
                            textAlign: "right",
                            color: "rgba(0, 0, 0, 0.6)",
                            fontSize: "0.875rem",
                            marginLeft: "auto",
                            paddingTop: "6px",
                          }}
                        >
                          How to complete ROE? <br />
                          How to order ROE forms
                          <br />
                          ROE Web Client Employer Consent Form
                        </Grid>
                      </Grid>
                      <EnhancedButtonPrimeReact
                        label="Load"
                        raised
                        severity={EnhancedButtonPrimeReactSeverity.Success}
                        onClickHandler={onLoadButtonClickedHandler}
                      />
                    </StandardPanel>
                  }
                  toolbar={
                    // <ROESetupToolbar
                    // 	onResetClicked={onResetClicked}
                    // 	// onDeleteClicked={onDeleteClicked}
                    // 	isSubmitting={false}
                    // 	formMethods={formMethods}
                    // 	pageTitle="ROE Setup"
                    // />
                    <></>
                  }
                  leftColumnContent={
                    <>
                      <StandardPanel
                        title="Block - 2 Serial No. of ROE Amended or Replaced"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        {/*<RHookFormTextField
                          id="serialNoOfRoeAmendedOrReplaced"
                          testId={`serialNoOfRoeAmendedOrReplaced`}
                        />*/}
                        <RHookFormMaskedTextField
                          id="serialNoOfRoeAmendedOrReplaced"
                          testId={`${testId}-serialNoOfRoeAmendedOrReplaced`}
                          inputMaskPattern={"000000000"}
                        // placeholder={"000000000"}
                        />
                      </StandardPanel>
                      <StandardPanel
                        title="Block - 4 Employer's Name And Address"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        <div style={{ fontSize: "0.875rem" }}>
                          {companyInfo && companyInfo.legalName} <br />        {/* umair bhai krwa rhy   */}
                          {companyInfo && companyInfo.address.addressLine1} <br />
                          {companyInfo && companyInfo.address.city} {companyInfo && companyInfo.address.province.shortCode}
                        </div>
                      </StandardPanel>

                      <StandardPanel
                        title="Block - 7 Postal Code"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        <p style={{ fontSize: "0.875rem", margin: 0 }}>
                          {companyInfo && companyInfo.address.postCode}
                        </p>
                      </StandardPanel>
                      <StandardPanel
                        title="Block - 8 Social Insurance Number"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        <p style={{ fontSize: "0.875rem", margin: 0 }}>
                          {employeeDataById && employeeDataById.socialInsuranceNumber}
                        </p>
                      </StandardPanel>
                      <StandardPanel
                        title="Block - 10 First Day Worked"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        <p style={{ fontSize: "0.875rem", margin: 0 }}>
                          {selectedROEData && formatDateToShow(selectedROEData.firstDayWorked)}
                        </p>
                      </StandardPanel>
                      <StandardPanel
                        title="Block - 12 Final Pay Period Ending Date"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        <p style={{ fontSize: "0.875rem", margin: 0 }}>
                          {/* Feb 14, 2024  */}
                          {selectedROEData && formatDateToShow(selectedROEData.finalPayperiodEndDate)}
                          {/* getting by payperiod and enddate */}
                          {/* //enddate falls on which record startdate and endate in payroll schedule and get that item end date */}
                        </p>
                      </StandardPanel>
                      <StandardPanel
                        title="Block - 14 Expect Date of recall"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        <EnhancedRadioGroupRHF
                          name="expectedDateOfRecall"
                          selectedValue={200}
                          key="expectedDateOfRecall"
                          testId="expectedDateOfRecall"
                          options={[
                            {
                              label: "Enter Date",
                              value: 100,
                            },
                            {
                              label: "Unknown",
                              value: 300,
                            },
                            {
                              label: "Not Returning",
                              value: 200,
                            },
                          ]}
                          onChangeHandler={onExpectDateOfRecallChangeHandler}
                          displayAsRow={false}
                        />

                        <Box sx={{ marginTop: "23px" }}>
                          <RHookFormDatePicker
                            name="expectedDateOfRecallDate"
                            testId="expectedDateOfRecallDate"
                            label="Expect Date of recall"
                            labelPosition={LabelPosition.Top}
                            format="M dd, yy"
                            disabled={
                              expectedDateOfRecall !== 100 ? true : false
                            }
                          />
                        </Box>
                      </StandardPanel>
                      <StandardPanel
                        title="Block - 15B Total Insurable hours according to chart"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                      // borderBottom={true}
                      >
                        <RHookFormNumberField
                          id="totalInsurableEarningAccordingToChart"
                          testId={`totalInsurableEarningAccordingToChart`}
                        />
                      </StandardPanel>
                    </>
                  }
                  rightColumnContent={
                    <>
                      <StandardPanel
                        title="Block - 3 Employer's Payroll Reference No."
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        {/* <RHookFormTextField
                          id="employerPayrollReferenceNo"
                          testId={`employerPayrollReferenceNo`}
                        /> */}
                        <p style={{ fontSize: "0.875rem", margin: 0 }}>
                          {/* {employeeDataById && getPayFrequencyLabelByGivingCode(employeeDataById.employeePayroll.payFrequency)} */}
                          {/* {employeeDataById && employeeDataById.employeePayroll.payFrequency} */}
                          {selectedROEData && selectedROEData.employerPayrollReferenceNo}
                        </p>
                      </StandardPanel>
                      <StandardPanel
                        title="Block - 5 Canada Revenue Agency Business No. (BN)"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        <p style={{ fontSize: "0.875rem", margin: 0 }}>
                          {companyInfo && companyInfo.craBusinessNo}
                        </p>
                      </StandardPanel>
                      <StandardPanel
                        title="Block - 6 Pay Period Type"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        <p style={{ fontSize: "0.875rem", margin: 0 }}>
                          {/* {employeeDataById && getPayFrequencyLabelByGivingCode(employeeDataById.employeePayroll.payFrequency)} */}
                          {/* {employeeDataById && employeeDataById.employeePayroll.payFrequency} */}
                          {selectedROEData && selectedROEData.payPeriodLabel}
                        </p>
                      </StandardPanel>
                      <StandardPanel
                        title="Block - 9 Employee's Name And Address"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        <div style={{ fontSize: "0.875rem" }}>
                          {employeeDataById && employeeDataById.firstName} {employeeDataById && employeeDataById.lastName} <br />
                          {employeeDataById && employeeDataById.address.addressLine1} <br />
                          {employeeDataById && employeeDataById.address.city} {employeeDataById && employeeDataById.address.province.shortCode} {employeeDataById && employeeDataById.address.postCode}
                        </div>
                      </StandardPanel>
                      <StandardPanel
                        title="Block - 11 Last Day for which paid"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        <p style={{ fontSize: "0.875rem", margin: 0 }}>
                          {formatDateToShow(endDate)}
                        </p>
                      </StandardPanel>
                      <StandardPanel
                        title="Block - 13 Occupation"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        <RHookFormTextField
                          id="occupation"
                          testId={`occupation`}
                        />
                      </StandardPanel>
                      <StandardPanel
                        title="Block - 15A Total Insurable hours according to chart"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                        borderBottom={true}
                      >
                        {/* <RHookFormNumberField
                          id="totalInsurableHoursAccordingToChart"
                          testId={`totalInsurableHoursAccordingToChart`}
                        /> */}
                        <p style={{ fontSize: "0.875rem", margin: 0 }}>
                          {/* {employeeDataById && getPayFrequencyLabelByGivingCode(employeeDataById.employeePayroll.payFrequency)} */}
                          {/* {employeeDataById && employeeDataById.employeePayroll.payFrequency} */}
                          {selectedROEData && selectedROEData.totalInsurableHoursAccordingToChart}
                        </p>
                      </StandardPanel>
                      <StandardPanel
                        title="Block - 16 Reason for issuing this ROE (enter code)"
                        testId={`${testId}-slip-data`}
                        borderHide={true}
                      // borderBottom={true}
                      >
                        <EnhancedDropDownRHF
                          selectName="reasonForIssuringThisRoe"
                          testId={`reasonForIssuringThisRoe`}
                          items={reasonForIssuringThisRoeDDL}
                          showEmpty
                        />
                        <Divider
                          type="dashed"
                          pt={{ root: { style: { margin: 0 } } }}
                        />
                        <Grid
                          container
                          size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                          sx={{ paddingLeft: "6px" }}
                        >
                          <div
                            style={{
                              padding: "16px 16px 2rem 0",
                              fontSize: "1rem",
                              fontWeight: 700,
                            }}
                          >
                            For Further Information Contact
                          </div>
                          <Grid
                            size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
                          >
                            <EnhancedDropDownRHF
                              selectName="contactPerson"
                              testId={`reasonForIssuringThisRoe`}
                              items={
                                contactPersonDDL && contactPersonDDL.message
                                  ? []
                                  : contactPersonDDL
                                    ? contactPersonDDL
                                    : []
                              }
                              showEmpty
                            />
                          </Grid>
                          <Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
                            <Link
                              to={`/company/filing-resources/setup`}
                              className="no-underline"
                              style={{
                                color: theme.palette.primary.light,
                                marginTop: 0,
                                marginLeft: "5px",
                              }}
                            >
                              add/edit
                            </Link>
                          </Grid>
                          {contactPersonDDL &&
                            <Typography sx={{ fontSize: "0.875rem" }}>
                              Telephone number <span>{contactPersonPhoneNumber && contactPersonPhoneNumber.replace(
                                /(\d{3})(\d{3})(\d{4})/,
                                "($1) $2-$3"
                              )}</span>
                            </Typography>
                          }
                        </Grid>
                      </StandardPanel>
                    </>
                  }
                  showTwoColumnCombineBorder={true}
                  testId="t4-slip-setup-form"
                />
                <SingleColumnLayout
                  toolbar={<></>}
                  showFullDiaplay={true}
                  showToolbar={false}
                  testId={"block-15c-Complete-according-to-chart"}
                >
                  <StandardPanel
                    title={"Block - 15C Complete according to chart"}
                    testId={"block-15c-Complete-according-to-chart"}
                    topPadding={2}
                  >
                    <CompleteAccordingToChartSetupFieldsPanel fields53For15c={fields53For15c} />
                  </StandardPanel>
                </SingleColumnLayout>
                <SingleColumnLayout
                  toolbar={<></>}
                  showFullDiaplay={true}
                  showToolbar={false}
                  testId={"block-17"}
                >
                  <Box
                    sx={{
                      "& .MuiCardContent-root": { display: "none" },
                    }}
                  >
                    <StandardPanel
                      title={
                        "Block - 17 Only complete if payments or benefits (other than regular pay) paid in or in anticipation of the final pay period or payable at a later date"
                      }
                      testId={"block-17"}
                      topPadding={2}
                    >
                      <></>
                    </StandardPanel>
                  </Box>
                </SingleColumnLayout>
                <hr style={{ visibility: "hidden", margin: 7 }} />
                <TwoColumnLayout
                  toolbar={<></>}
                  showToolbar={false}
                  leftColumnContent={
                    <StandardPanel
                      title={"Block - 17A Vacation Pay"}
                      testId={"block-17a"}
                      topPadding={2}
                      borderHide={true}
                    >
                      <>
                        <EnhancedDropDownRHFWithLabel
                          label="Description"
                          labelPosition={LabelPosition.Top}
                          selectName="description"
                          testId={`description`}
                          items={[
                            { label: "Included with each pay", value: 200 },
                            {
                              label: "Paid because no longer working",
                              value: 300,
                            },
                            {
                              label: "Paid for a vacation leave period",
                              value: 400,
                            },
                            {
                              label:
                                "Anniversary (Paid on a specific date each year)",
                              value: 100,
                            },
                          ]}
                          showEmpty
                        />
                        <RHookFormDatePicker
                          name="startDateBlock17A"
                          testId="startDate"
                          label="Start Date"
                          labelPosition={LabelPosition.Top}
                          format="M dd, yy"
                        />
                        <RHookFormDatePicker
                          name="endDateBlock17A"
                          testId="endDate"
                          label="End Date"
                          labelPosition={LabelPosition.Top}
                          format="M dd, yy"
                        />
                        <RHookFormNumberFieldWithLabel
                          label="Amount"
                          id={"block17AAmount"}
                          testId={"17a-amount"}
                        />
                        <EnhancedCheckboxRHF
                          name="addToBlock15bC"
                          checked={false}
                          testId="Activate-Account"
                          checkboxLabel="Add to block 15B/15C"
                        />
                      </>
                    </StandardPanel>
                  }
                  rightColumnContent={
                    <StandardPanel
                      title={"Block - 17B Statutory holidays"}
                      testId={"block - 17b statutory holidays"}
                      topPadding={2}
                      borderHide={true}
                    >
                      {/* <block17BSetupFieldsPanelTableData /> */}
                      <Block17BSetupFieldsPanelTableFieldsTable
                        Block17BSetupFieldsPanelTableUpdatedData={(data: any) =>
                          setBlock17BSetupFieldsPanelTableUpdatedData(data)
                        }
                        Block17BSetupFieldsPanelTableDataItems={
                          Block17BSetupFieldsPanelTableDataItems
                        }
                      />
                    </StandardPanel>
                  }
                  testId={"block-17A"}
                />
                <hr style={{ visibility: "hidden", margin: 7 }} />
                {/* <Block17BSetupFieldsPanel /> */}



                <SingleColumnLayout
                  toolbar={<></>}
                  showFullDiaplay={true}
                  showToolbar={false}
                  testId={"block-17c-Other-monies-(Specify)"}
                >
                  <StandardPanel
                    title={"Block - 17C Other monies (Specify)"}
                    testId={"block-17c-Other-monies-(Specify)"}
                    topPadding={2}
                  >
                    {/* <Block17CSetupFieldsPanel /> */}
                    <Block17COtherMoniesFieldsTable
                      block17COtherMoniesUpdatedData={(data: any) =>
                        setBlock17COtherMoniesUpdatedData(data)
                      }
                      block17COtherMoniesDataItems={
                        block17COtherMoniesDataItems
                      }
                    />
                  </StandardPanel>
                </SingleColumnLayout>

                <SingleColumnLayout
                  toolbar={<></>}
                  showFullDiaplay={true}
                  showToolbar={false}
                  testId={"block-19"}
                >
                  <StandardPanel
                    title={
                      "Block - 19 Paid sick/maternity/parental/compassionate care leave or group wage loss indemnity payment"
                    }
                    testId={"block-19"}
                    topPadding={2}
                  >


                    <Block19PaidFieldsTableData
                      block19PaidFieldsTableUpdatedData={(data: any) =>
                        setblock19PaidFieldsTableUpdatedData(data)
                      }
                      block19PaidFieldsDataItems={
                        block19PaidFieldsDataItems
                      }
                    />
                  </StandardPanel>
                </SingleColumnLayout>

                <hr style={{ visibility: "hidden", margin: 7 }} />
                <TwoColumnLayout
                  toolbar={<></>}
                  showToolbar={false}
                  leftColumnContent={
                    <>
                      <StandardPanel
                        title={"Block - 18 Comments"}
                        testId={"block-18"}
                        topPadding={2}
                        borderHide={true}
                        borderBottom={true}
                      >
                        <EnhancedTextAreaFieldRHF
                          label="Comments"
                          id="comments"
                          testId={`comments`}
                          labelPosition={LabelPosition.Top}
                        // minRows={7.5}
                        />
                      </StandardPanel>

                    </>
                  }
                  rightColumnContent={
                    <StandardPanel
                      title={"Block - 20 Communication preferred in"}
                      testId={"block-20"}
                      topPadding={2}
                      borderHide={true}
                    >
                      <EnhancedRadioGroupRHF
                        name="communicationPrefferedIn"
                        selectedValue={100}
                        key="communicationPrefferedIn"
                        testId="communicationPrefferedIn"
                        options={[
                          {
                            label: "English",
                            value: 100,
                          },
                          {
                            label: "French",
                            value: 200,
                          },
                        ]}

                        // onChangeHandler={onExpectDateOfRecallChangeHandler}
                        displayAsRow={false}
                      />
                    </StandardPanel>
                  }
                  testId={"block-17A"}
                />
              </Grid>
              <Grid size={{ xs: 0, sm: 0, md: 1, lg: 1, xl: 1 }}></Grid>
              <Grid
                size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                sx={{ marginTop: "16px" }}
              >
                <ResourceDDLDataTableForSlips
                  rows={
                    employeeDDLItems && upadtedEmployeeDDLListItems
                      ? upadtedEmployeeDDLListItems
                      : []
                  }
                  selectedEmployee={selectedEmployee}
                  selectedResourceSlipList={selectedResourceSlipList}
                  selectedResourceSlip={selectedResourceSlip}
                  onResourceSlipSelectionChangeHandler={
                    onResourceSlipSelectionChangeHandler
                  }
                  tableScrollHeight={"60vh"}
                  // selectedId={selectedROEData && id && selectedROEData?.employeeId}
                  selectedId={selectedEmployee && selectedEmployee}
                  tableContainerRef={tableScrollRef}
                />
              </Grid>
              <Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
            </Grid>
          </form>
        </FormProvider>
        <EnhancedSnackbar
          message={snackbarData.message}
          onCloseHandler={onSnackbarClosed}
          severity={snackbarData.severity}
          testId={`${testId}-snackbar`}
          open={snackbarData.open}
          autoHide={snackbarData.autoHide}
        />
      </Grid>
    </>
  );
};
